import React, {Component} from 'react'
import {
  StyleSheet,
  View,
  Dimensions,
  ScrollView,
  TextInput,
  ActivityIndicator,
} from 'react-native'
import {Text, Input, Button} from 'react-native-elements'

import MediaList from './MediaList'

import {mediaList} from './network'
import TimePoint from './TimePoint'

import cloneDeep from 'lodash/cloneDeep'
const WIDTH = Dimensions.get('window').width
const VIEW_WIDTH = WIDTH / 1.3
const HEIGHT = Dimensions.get('window').height
class Media extends Component {
  constructor (props) {
    super(props)
    this.state = {
      media: [],
      isLoading: true,
    }
  }

  componentDidMount () {
    mediaList(this.props.mediaType)
      .then(response => {
        console.log(response)
        this.setState({
          media: response,
          isLoading: false,
        })
      })
      .catch(error => {
        this.setState({
          isLoading: false,
        })
        console.log(error)
      })
  }
  loadSaveOrCancelButtonView = () => {
    return (
      <View style={styles.saveOrCancelButtonStyle}>
        <Button
          buttonStyle={styles.cancelButtonStyle}
          title={'CANCEL'}
          titleStyle={styles.cancelButtonTitleStyle}
          onPress={this.props.onFileSelectCancelPress}
        />
      </View>
    )
  }

  render () {
    return this.state.isLoading ? (
      <ActivityIndicator />
    ) : (
      <View style={styles.elementStyle}>
        <MediaList
          data={this.state.media}
          onFileSelect={this.props.onFileSelect}
        />
        {this.loadSaveOrCancelButtonView()}
      </View>
    )
  }
}

const styles = StyleSheet.create({
  elementStyle: {
    width: VIEW_WIDTH,
    height: HEIGHT,
  },
  container: {
    backgroundColor: 'white',
    borderRadius: 20,
  },
  saveOrCancelButtonStyle: {
    flexDirection: 'row',
    width: VIEW_WIDTH,
    justifyContent: 'flex-end',
  },
  cancelButtonStyle: {
    width: 100,
    height: 30,
    backgroundColor: '#eeeeee',
    borderRadius: 2,
  },
  cancelButtonTitleStyle: {
    color: 'black',
    fontSize: 15,
  },
})

export default Media
